export const blogFirstKey = 'content';
